import AnnouncementBar from "@/components/landing/AnnouncementBar";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import NoTouch from "@/components/landing/NoTouch";
import Differentiation from "@/components/landing/Differentiation";
import EmotionalShowcase from "@/components/landing/EmotionalShowcase";
import WhyChooseUs from "@/components/landing/WhyChooseUs";
import Process from "@/components/landing/Process";
import WhatWeTake from "@/components/landing/WhatWeTake";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import StickyMobileCTA from "@/components/landing/StickyMobileCTA";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <AnnouncementBar />
      <Header />
      <main className="pb-20 md:pb-0">
        <Hero />
        <NoTouch />
        <Differentiation />
        <EmotionalShowcase />
        <WhyChooseUs />
        <Process />
        <WhatWeTake />
        <Testimonials />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
